import React from 'react';
import { PmPaymentForm } from './PmPaymentForm';
import { XBezahldienstForm } from './XBezahldienstForm';
import { EPayBLForm } from './EPayBLForm';
import { PaymentSubFormProps } from './Payment.types';

export function PaymentModalRouter(props: PaymentSubFormProps) {
  switch (props.parentState.selectedService.serviceCode) {
    case 'pmpayment':
      return <PmPaymentForm {...props} />;
    case 'xbezahl':
      return <XBezahldienstForm {...props} />;
    case 'payBl':
      return <EPayBLForm {...props} />;
    default:
      return null;
  }
}
